var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documentHash)?_c('div',{staticClass:"documentHash"},[_c('div',{staticClass:"label"},[_vm._v("documentHash:")]),_vm._v(" "),_c('div',{staticClass:"hash"},[_c('buttonCopy',{staticClass:"ml-1",attrs:{"value":_vm.documentHash}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }